import { createSlice, createAction } from '@reduxjs/toolkit';

// Saga-triggered actions
export const createReportAction = createAction('reports/createReport');
export const fetchReportsAction = createAction('reports/fetchReports');
export const pollReportStatusAction = createAction('reports/pollReportStatus');
export const stopPollingAction = createAction('reports/stopPolling');
export const checkExistingReportAction = createAction('reports/checkExisting');
export const deleteReportAction = createAction('reports/deleteReport');

const initialState = {
    reports: [],
    total: 0,
    loading: false,
    creating: false,
    activeReport: null, // currently being polled
    existingReport: null, // same-day full report
    checkingExisting: false,
    error: null,
};

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setCreating(state, action) {
            state.creating = action.payload;
        },
        reportsFetched(state, action) {
            state.reports = action.payload.reports;
            state.total = action.payload.total;
            state.loading = false;
        },
        reportCreated(state, action) {
            state.creating = false;
            state.activeReport = action.payload;
            // Prepend to list
            state.reports = [action.payload, ...state.reports];
            state.total += 1;
        },
        reportStatusUpdated(state, action) {
            const report = action.payload;
            state.activeReport = report;
            // Also update in list
            const idx = state.reports.findIndex(r => r._id === report._id);
            if (idx !== -1) {
                state.reports[idx] = report;
            }
        },
        clearActiveReport(state) {
            state.activeReport = null;
        },
        setExistingReport(state, action) {
            state.existingReport = action.payload;
            state.checkingExisting = false;
        },
        setCheckingExisting(state, action) {
            state.checkingExisting = action.payload;
        },
        reportDeleted(state, action) {
            state.reports = state.reports.filter(r => r._id !== action.payload);
            state.total = Math.max(0, state.total - 1);
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.creating = false;
        },
    },
});

export const {
    setLoading,
    setCreating,
    reportsFetched,
    reportCreated,
    reportStatusUpdated,
    clearActiveReport,
    reportDeleted,
    setExistingReport,
    setCheckingExisting,
    setError,
} = reportsSlice.actions;

// Selectors
export const getReports = state => state.reports.reports;
export const getReportsTotal = state => state.reports.total;
export const getReportsLoading = state => state.reports.loading;
export const getReportsCreating = state => state.reports.creating;
export const getActiveReport = state => state.reports.activeReport;
export const getExistingReport = state => state.reports.existingReport;
export const getCheckingExisting = state => state.reports.checkingExisting;

export default reportsSlice.reducer;
